<template>
  <div class="row">
    <div class="col-md-3"></div>
    <div class="col-md-6">
      <div class="card-body">
        <div class="card card-secondary card-outline col-md-12">
          <div class="card-header">
            <h3 class="card-title">
              <i class="fas fa-paste"></i>
              Agregar Empresas
            </h3>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-8">
                <div class="form-group">
                  <label for="empresa">Empresa</label>
                  <v-select
                    :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                    v-model="empresa"
                    label="razon_social"
                    :options="listasForms.empresas"
                    :filterable="
                      listasForms.empresas.length === 0 ||
                        listasForms.empresas.length > 10
                    "
                    :disabled="
                      $parent.opcion == 1 ||
                        ($parent.form.id &&
                          choferesHasEmpresas.length > 0) ||
                        debeDeshabilitarCreacion ||
                        (!$parent.form.id &&
                          !$store.getters.can('argentina.choferes.create')) ||
                        ($parent.form.id &&
                          !$store.getters.can('argentina.choferes.edit'))
                    "
                    @input="selectEmpresa()"
                  ></v-select>
                </div>
              </div>
              <div class="col-md-2">
                <br />
                <button
                  class="btn btn-dark col-md-12 mt-1"
                  @click="saveEmpresa()"
                  id="asoc_empresa"
                  style="display: none"
                  v-show="formEmpresa.empresa_id && $parent.form.id"
                  :disabled="
                    $parent.opcion == 1 ||
                      !$store.getters.can('argentina.choferes.edit')
                  "
                >
                  <i class="fas fa-save"></i><br />
                </button>
              </div>
              <div class="col-md-12" v-if="!$parent.form.id">
                <div class="alert alert-info" v-if="!usuarioTieneEmpresas">
                  <i class="icon fas fa-info-circle"></i>
                  Seleccione una empresa. Se asignará automáticamente al guardar
                  el chofer.
                </div>
                <div class="alert alert-success" v-else>
                  <i class="icon fas fa-check-circle"></i>
                  Se ha seleccionado automáticamente su empresa asignada. Se
                  guardará al crear el chofer.
                </div>
              </div>
              <div class="card-body p-0" v-if="$parent.form.id">
                <table
                  id="empresas"
                  class="table table-bordered table-striped table-hover table-sm"
                >
                  <thead>
                    <tr>
                      <th>Empresa</th>
                      <th style="width: 20px">Acción</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="data in choferesHasEmpresas" :key="data.id">
                      <td v-text="data.razon_social"></td>
                      <td class="text-center">
                        <button
                          type="button"
                          class="btn btn-danger btn-sm"
                          @click="
                            destroyEmpresa(data.id, data.pivot.conductor_id)
                          "
                          :disabled="$parent.opcion == 1"
                        >
                          <i class="fas fa-trash-alt"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { required } from "vuelidate/lib/validators";
import vSelect from "vue-select";
import $ from "jquery";

export default {
  name: "ChoferEmpresa",
  components: {
    vSelect,
  },
  data() {
    return {
      empresa: null,
      formEmpresa: {},
      choferesHasEmpresas: {},
      empresaSeleccionadaCreacion: null, // Empresa seleccionada al crear
      listasForms: {
        empresas: [],
      },
    };
  },
  validations: {
    formEmpresa: {
      empresa_id: {
        required,
      },
    },
  },
  computed: {
    empresaUsuarioUnica() {
      const empresasUsuario = this.$store.getters.getUser.empresas;
      return empresasUsuario && empresasUsuario.length === 1;
    },
    usuarioTieneEmpresas() {
      const empresasUsuario = this.$store.getters.getUser.empresas;
      return empresasUsuario && empresasUsuario.length > 0;
    },
    debeDeshabilitarCreacion() {
      // Al crear: deshabilitar si tiene UNA O MÁS empresas asignadas
      if (!this.$parent.form.id) {
        const empresasUsuario = this.$store.getters.getUser.empresas;
        return empresasUsuario && empresasUsuario.length > 0;
      }
      return false;
    },
  },
  methods: {
    selectEmpresa() {
      this.formEmpresa.empresa_id = null;
      // Si está creando, guardar la empresa seleccionada
      if (this.empresa) {
        this.empresaSeleccionadaCreacion = this.empresa;
        this.formEmpresa.empresa_id = this.empresa.id;
        // Notificar al padre que hay empresa seleccionada
        this.$nextTick(() => {
          this.$parent.empresaSeleccionada = true;
        });
      }

      $("#asoc_empresa").css("display", "block");
    },

    // Método público para obtener la empresa seleccionada al crear
    getEmpresaSeleccionada() {
      // Si no hay empresaSeleccionadaCreacion pero hay empresa actual, usarla
      if (
        !this.empresaSeleccionadaCreacion &&
        this.empresa &&
        this.empresa.id
      ) {
        return this.empresa;
      }

      return this.empresaSeleccionadaCreacion;
    },

    // Método público para validar si tiene empresa seleccionada
    tieneEmpresaSeleccionada() {
      if (this.$parent.form.id) {
        // Si está editando, verificar si tiene empresas asignadas
        return (
          this.choferesHasEmpresas && this.choferesHasEmpresas.length > 0
        );
      } else {
        // Si está creando, verificar si seleccionó una empresa
        return this.empresaSeleccionadaCreacion !== null;
      }
    },

    cargarEmpresasUsuario() {
      const empresasUsuario = this.$store.getters.getUser.empresas;

      if (empresasUsuario && empresasUsuario.length > 0) {
        // Si el usuario tiene empresas asignadas
        this.listasForms.empresas = empresasUsuario;

        // Si el chofer no tiene empresas asignadas aún, auto-seleccionar la primera
        if (this.choferesHasEmpresas.length === 0) {
          this.empresa = {
            id: empresasUsuario[0].id,
            razon_social: empresasUsuario[0].razon_social,
          };
          this.formEmpresa.empresa_id = empresasUsuario[0].id;

          // Si está creando, guardar como empresa seleccionada
          if (!this.$parent.form.id) {
            this.empresaSeleccionadaCreacion = this.empresa;
            // Notificar al padre que hay empresa seleccionada usando nextTick
            this.$nextTick(() => {
              this.$parent.empresaSeleccionada = true;
            });
          }

          $("#asoc_empresa").css("display", "block");
        }
      } else {
        // Si no tiene empresas asignadas, cargar solo empresas de Argentina (pais_id 3)
        axios
          .get("/api/argentina/empresas/lista", { params: { pais_id: 3 } })
          .then((response) => {
            this.listasForms.empresas = response.data;
          })
          .catch((error) => {
            this.$swal({
              icon: "error",
              title: `Error al cargar empresas: ${error}`,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    getEmpresa() {
      this.cargarEmpresasUsuario();
    },

    getChoferesHasEmpresas() {
      // Si no hay ID (creando), no hay empresas asignadas aún
      if (!this.$parent.form.id) {
        this.choferesHasEmpresas = [];
        return;
      }

      // Si hay ID (editando), cargar empresas del chofer
      axios
        .get("/api/argentina/choferes/" + this.$parent.form.id)
        .then((response) => {
          this.choferesHasEmpresas = response.data[0].empresas;
        });
    },

    saveEmpresa() {
      this.formEmpresa.conductor_id = this.$parent.form.id;
      this.formEmpresa.accion = true;
      axios({
        method: "PUT",
        url: "/api/argentina/choferes/assingOrRevokeEmpresa",
        data: this.formEmpresa,
      })
        .then(() => {
          this.formEmpresa = {};
          this.empresa = {};
          this.$swal({
            icon: "success",
            title: "Se guardo exitosamente...",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.getChoferesHasEmpresas();
          $("#asoc_empresa").css("display", "none");
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrio un error, vuelva a intentarlo..." + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    destroyEmpresa(idEmpresa, idConductor) {
      this.$swal({
        title: "Esta seguro de eliminar esta empresa?",
        text: "Los cambios no se pueden revertir!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, Eliminar!",
      }).then((result) => {
        // <--
        if (result.value) {
          axios({
            method: "PUT",
            url: "/api/argentina/choferes/assingOrRevokeEmpresa",
            data: {
              empresa_id: idEmpresa,
              conductor_id: idConductor,
              accion: false,
            },
          }).then(() => {
            this.getChoferesHasEmpresas();
            this.$swal({
              icon: "success",
              title: "Se elimino la empresa exitosamente...",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 4000,
              timerProgressBar: true,
            });
          });
        }
      });
    },
  },
  async mounted() {
    await this.getChoferesHasEmpresas();
    this.getEmpresa();
    // Cargar empresas del usuario para auto-selección
    this.cargarEmpresasUsuario();
  },
  watch: {
    "$parent.form.id": async function(newVal, oldVal) {
      // Si el ID cambia de null a un valor (después de crear), recargar las empresas
      if (oldVal === undefined && newVal) {
        await this.getChoferesHasEmpresas();
      }
    },
  },
};
</script>
